<div class="rd-widget table-widget">
  <table class="widget-large cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" [attr.colspan]="77" class="widget-grid-column" style="text-align: start;">
            <widget-value class="widget-grid-column" [align]="'left'" [color]="'white'" [bold]="true">Sales Grid</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="7">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="7">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">Subject</widget-value>
          </th>
          <ng-container *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
            <th *ngIf="item < 10" scope="col" colspan="7">
              <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'Comp ' + item}}</widget-value>
            </th>
          </ng-container>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">
      <ng-container *ngFor="let rowEntry of widgetData.processedData.rowData; let i = index">
        <dynamic-growth-row [row]="i + 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': i % 2 === 0}">
            <td colspan="7">
              {{rowEntry[0].label}}
            </td>
            <ng-container *ngFor="let col of rowEntry">
              <td colspan="7" style="color:black">{{ col | rdLocalizedDynamicField }}</td>
            </ng-container>
          </tr>
        </dynamic-growth-row>
      </ng-container>
      <dynamic-growth-row [row]="widgetData.processedData.rowData.length + 3" [widget]="this">
        <tr class="empty">&nbsp;</tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.processedData.rowData.length + 4" [widget]="this">
        <tr class="empty">&nbsp;</tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.processedData.rowData.length + 5" [widget]="this">
        <tr class="row-bottom dark-grey-line">
          <td colspan="20">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">Summary Indicators</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">Range</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">Average</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">Median</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.processedData.rowData.length + 6" [widget]="this">
        <tr class="row-bottom light-grey-line">
          <td colspan="20">
            <widget-value [align]="'left'">Comparables - Unadjusted</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'">{{widgetData.bottomRows.usSalesGridRangeComparablesUnadjusted}}</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'">{{widgetData.bottomRows.usSalesGridAverageComparablesUnadjusted}}</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'">{{widgetData.bottomRows.usSalesGridMedianComparablesUnadjusted}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.processedData.rowData.length + 7" [widget]="this">
        <tr class="row-bottom">
          <td colspan="20">
            <widget-value [align]="'left'">Comparables - Adjusted</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'">{{widgetData.bottomRows.usSalesGridRangeComparablesAdjusted}}</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'">{{widgetData.bottomRows.usSalesGridAverageComparablesAdjusted}}</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'">{{widgetData.bottomRows.usSalesGridMedianComparablesAdjusted}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.processedData.rowData.length + 8" [widget]="this">
        <tr class="header-red row-bottom">
          <td colspan="20">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">Reconciled Unit Value</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'">&nbsp;</widget-value>
          </td>
          <td colspan="19">
            <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{widgetData.bottomRows.usSalesGridReconciledUnitValue}}</widget-value>
          </td>
          <td colspan="19">
            &nbsp;
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>
